
import { Card } from "@/components/ui/card";
import { Lock } from "lucide-react";

interface RecipeCardProps {
  title: string;
  description?: string | null;
  imageUrl: string | null;
  visibility: 'public' | 'subscription';
  isSubscribed: boolean;
  profileUsername: string;
  recipeId: string;
  type?: 'recipe' | 'package';
}

export const RecipeCard = ({
  title,
  description,
  imageUrl,
  visibility,
  isSubscribed,
  profileUsername,
  recipeId,
  type = 'recipe'
}: RecipeCardProps) => {
  const isLocked = visibility === 'subscription' && !isSubscribed;
  const normalizedUsername = profileUsername.toLowerCase().replace(/\s+/g, '');
  const recipeLink = type === 'package' 
    ? `/packages/${recipeId}`
    : `/${normalizedUsername}/${recipeId}`;

  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  return (
    <Card className="p-4 h-[360px] flex flex-col relative">
      <div className="flex-1">
        {/* Image container - always visible regardless of lock status */}
        {!isLocked ? (
          <a href={recipeLink}>
            <div className="relative w-full h-48 mb-4 bg-gray-100 rounded-lg overflow-hidden">
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt={title}
                  className="w-full h-full object-cover select-none"
                  onContextMenu={handleContextMenu}
                  draggable="false"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-gray-400">
                  No image
                </div>
              )}
            </div>
          </a>
        ) : (
          <div className="relative w-full h-48 mb-4 bg-gray-100 rounded-lg overflow-hidden cursor-not-allowed">
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={title}
                className="w-full h-full object-cover select-none"
                onContextMenu={handleContextMenu}
                draggable="false"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400">
                No image
              </div>
            )}
            <div className="absolute top-2 right-2 bg-gray-900/80 text-white p-2 rounded-full">
              <Lock className="w-4 h-4" />
            </div>
          </div>
        )}

        {/* Title, author, and description */}
        {!isLocked ? (
          <a href={recipeLink}>
            <h3 className="text-xl font-semibold mb-1">{title}</h3>
            <p className="text-sm text-gray-500 mb-2">By {profileUsername}</p>
            {description && (
              <p className="text-gray-600 line-clamp-2">{description}</p>
            )}
          </a>
        ) : (
          <div className="cursor-not-allowed">
            <h3 className="text-xl font-semibold mb-1">{title}</h3>
            <p className="text-sm text-gray-500 mb-2">By {profileUsername}</p>
            {description && (
              <p className="text-gray-600 line-clamp-2">{description}</p>
            )}
          </div>
        )}
      </div>
    </Card>
  );
};
